import { SocketController } from './SocketController.ts';
import { SocketLobbyListen } from './SocketLobbyListen.ts';
import { SocketGameListen } from './SocketGameListen.ts';
import { SocketMatchmakingListen } from './SocketMatchmakingListen.ts';
import { SocketShuffleListen } from './SocketShuffleListen.ts';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
import { SocketMonitor } from './SocketMonitor.ts';
import { RoomProtocolMapperClient } from '../RoomProtocolMapperClient.ts';
import { NetworkEnums } from '../../../../shared/GameEnums.ts';
import { ClientMessageSubType } from '@colonist/types';
import { ProtocolClient } from '../ProtocolClient.ts';
export class Socket {
    connect() {
        this.controller.enableConnect();
    }
    constructor(socketActionController){
        this.actionController = socketActionController;
        this.controller = new SocketController(UIAPIEndpoints.socketServerWSS());
        this.gameListener = new SocketGameListen(this.controller, this.actionController);
        this.lobbyListener = new SocketLobbyListen(this.controller, this.actionController);
        this.matchmakingListener = new SocketMatchmakingListen(this.controller, this.actionController);
        this.shuffleListener = new SocketShuffleListen(this.controller);
        this.monitor = new SocketMonitor(this.controller);
        this.controller.setStateHandler(NetworkEnums.State.RoomEvent, (event)=>{
            this.roomProtocolClient.emitEvent(event.type, event);
        });
        const sendRoomCommandToServer = (command)=>{
            this.controller.sender.sendToServerType(ClientMessageSubType.RoomCommand, 'lobby', command);
        };
        this.roomProtocolClient = new ProtocolClient(sendRoomCommandToServer);
        this.roomClient = new RoomProtocolMapperClient(this.roomProtocolClient);
    }
}
